import RCRAAgreements from "../pages/RCRAStudentForm/components/RCRAAgreements";

const RCRACustomComponents = {
  RCRAAgreements,
};

export default RCRACustomComponents;
